import { apiFetch } from "../utils/api";

export const makaniService = {

  async lookup(lat, lng) {
    const res = await apiFetch(`/api/makani/lookup?lat=${lat}&lng=${lng}`);
    if (!res) throw new Error('Network error');
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || `Lookup failed (${res.status})`);
    }
    const data = await res.json();
    return data.makaniNumber;
  }

};
